import FiltersController from '@/kenwood/Controllers/Listing/FiltersController';
import KenwoodCompareInitiator from '@/kenwood/Controllers/Listing/KenwoodCompareInitiator';
import KenwoodListingBackToPlpController from '@/kenwood/Controllers/Listing/KenwoodListingBackToPlpController';
import KenwoodPaginationController from '@/kenwood/Controllers/Listing/KenwoodPaginationController';
import { initPlpBVZeroReviews } from '@/utils/Controllers/Bazaarvoice/BVZeroReviewsController';
import GTMComparisonTool from '@/utils/Controllers/GTM/Operations/ComparisonTool';

document.addEventListener('DOMContentLoaded', () => {
  FiltersController();
  KenwoodListingBackToPlpController();
  KenwoodPaginationController();
  KenwoodCompareInitiator();
  GTMComparisonTool();
  initPlpBVZeroReviews();
});
